<template>
  <a-config-provider :theme="theme">
    <div id="app">
      <template v-if="route.path.startsWith('/user')">
        <router-view />
      </template>
      <template v-else>
        <BasicLayout />
      </template>
    </div>
  </a-config-provider>
</template>
<script setup lang="ts">
import BasicLayout from "@/layouts/BasicLayout.vue";
import { useRoute } from "vue-router";
import { computed, onMounted } from "vue";
import { useDarkModeStore } from "@/store/themeStore"; //  store 管理主题状态
import type ArcoVue from "@arco-design/web-vue";
type Theme = ArcoVue.Theme;

const themeStore = useDarkModeStore();
const theme = computed<Theme>(() => {
  return themeStore.isDark ? "dark" : "light";
});

const route = useRoute();
/**
 * 全局初始化函数，有全局单次调用的代码，都可以写到这里
 */
const doInit = () => {
  console.log("hello 欢迎来到我的项目");
};
onMounted(() => {
  doInit();
});
</script>
<style>
/* 1. 设置 body 的基础样式 */
body {
  /* 亮色模式背景：白色 */
  background-color: #ffffff;
  color: var(--color-text-1);
  margin: 0;
  transition: background-color 0.3s, color 0.3s;
}

/* 2. 当 body 有 arco-theme="dark" 属性时，应用暗黑背景 */
body[arco-theme="dark"] {
  /* 暗黑模式背景：Arco 默认的深色背景值 */
  background-color: #17171a;
  color: var(--color-text-1);
}

/* 3. 确保 #app 占满全屏，且背景透明 */
#app {
  min-height: 100vh;
  background-color: transparent;
}
</style>
